import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { authApi } from '../../Services/authApi';
import { RootState } from '../../store';

export const fetchTermClauseRedux = createAsyncThunk(
  'clauseTerm/fetchTermClause',
  async (id: string) => {
    return await authApi.get(`contracts/insights/${id}/term/`);
  }
);

interface ClauseTermState {
  loading: boolean;
  data: any;
  error?: string | null;
}

const initialState: ClauseTermState = {
  loading: false,
  data: null,
  error: null,
};

const clauseTermSlice = createSlice({
  name: 'clauseTerm',
  initialState,
  reducers: {
    resetClauseTerm: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTermClauseRedux.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermClauseRedux.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload;
      })
      .addCase(fetchTermClauseRedux.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch term clause';
      });
  },
});

export const { resetClauseTerm } = clauseTermSlice.actions;
export const selectClauseTerm = (state: RootState) => state.clauseTerm;
export default clauseTermSlice.reducer;
